import RichText from '@eneco/components/RichText/RichText';
import { Heading, Text } from '@eneco/sparky';
import type { Fields } from '@sitecore/types/GenericFormParagraph';

import { GenericFormFC, GenericFormParagraphProps } from '../../util';

function isGenericFormParagraph(field: Fields) {
  return field?.paragraph !== undefined;
}

const GenericFormParagraph: GenericFormFC<GenericFormParagraphProps> = ({ fields }) => {
  if (!isGenericFormParagraph(fields)) {
    return null;
  }
  const { paragraph } = fields;
  return (
    <>
      {(paragraph.value.title || paragraph.editable) && (
        <Heading as="h2" size="XS">
          {paragraph.value.title}
        </Heading>
      )}
      <Text>
        <RichText html={paragraph.value.content} />
      </Text>
    </>
  );
};

export default GenericFormParagraph;
